import React from 'react'

export default function PostFrequency() {

  return (
    <div>

    </div>
  )
}